import { USERNAME } from 'mk2/helpers/urls';

export const planGetPlusUrl = '/get-plus/';
export const planGetProUrl = '/get-pro/';
export const planChoosePlanUrl = '/plan/choose/'; // TBD '/plannew/choose/'
export const planPlanForUrl = `/plan/for/${USERNAME}/`;
